import { Button } from 'antd';
import { TbAlertTriangle, TbRefresh, TbUsers } from 'react-icons/tb';

import EmptyView from '@/shared/components/layouts/views/EmptySection';
import ListItemSkeleton from '@/shared/components/skeletons/ListItemSkeleton';

interface AccountSessionFeedbackProps {
    disabled: boolean;
    error?: string;
    loading: boolean;
    onRetry: () => void;
}

export default function AccountSessionFeedback({ disabled, error, loading, onRetry }: AccountSessionFeedbackProps) {
    if (loading) {
        return (
            <div role='status' aria-label='Loading accounts' aria-busy='true'>
                {[0, 1].map((row) => (
                    <ListItemSkeleton
                        key={row}
                        avatar
                        avatarShape='square'
                        avatarSize={32}
                        compact
                        style={{ paddingBlock: '0.75rem' }}
                    />
                ))}
            </div>
        );
    }

    if (error) {
        return (
            <div role='alert'>
                <EmptyView
                    icon={<TbAlertTriangle />}
                    height='12rem'
                    label='Unable to Load Accounts'
                    description={error}
                    extra={
                        <Button size='small' icon={<TbRefresh />} disabled={disabled} onClick={onRetry}>
                            Try again
                        </Button>
                    }
                />
            </div>
        );
    }

    return (
        <EmptyView
            icon={<TbUsers />}
            height='10rem'
            label='No Signed-In Accounts'
            description='Sign in to access your workspaces.'
        />
    );
}
